import { Box, Stack, useTheme } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import PageError from '../../assets/images/PageError';
import CustomButton from '../../components/button/ButtonComponent';
import { colors } from '../../components/theme/theme';
import { NavigationConfig } from '../../utils/navigation-constants';

export const NotFound: React.FC = () => {
    const theme = useTheme();
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(NavigationConfig.Login);
    };

    return (
        <Stack
            sx={{
                backgroundColor: colors.bluePreset[110],
                height: '100dvh',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                padding: theme.spacing(3),
            }}
        >
            <Stack
                sx={{
                    maxWidth: '550px',
                    width: '100%',
                    margin: '0 auto',
                    backgroundColor: 'transparent',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 4,
                    padding: theme.spacing(5),
                    gap: 3,
                }}
            >
                <Box
                    sx={{
                        maxWidth: '100%',
                        width: '363px',
                        height: 'auto',
                        textAlign: 'center',
                    }}
                >
                    <PageError />
                </Box>
                <CustomButton
                    variant="contained"
                    color="primary"
                    onClick={handleGoBack}
                    sx={{
                        marginTop: theme.spacing(1),
                    }}
                >
                    Go Back
                </CustomButton>
            </Stack>
        </Stack>
    );
};

export default NotFound;
